import React from 'react';

import { QuickFindStoreContainer } from '../index';

export const QuickFindStoreProvider = ({
	children,
}: {
	children: React.ReactNode;
}): React.JSX.Element => {
	return <QuickFindStoreContainer>{children}</QuickFindStoreContainer>;
};
